module.exports = __webpack_public_path__ + "static/img/iphone_room8.c28f1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room8.png
// module id = PArL
// module chunks = 0